import { render } from "./FormGrid.vue?vue&type=template&id=55cebd61&scoped=true"
import script from "./FormGrid.vue?vue&type=script&lang=js"
export * from "./FormGrid.vue?vue&type=script&lang=js"

import "./FormGrid.vue?vue&type=style&index=0&id=55cebd61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cebd61"]])

export default __exports__